import { render, staticRenderFns } from "./CreateUpdateTemplateCategory.vue?vue&type=template&id=0c0d8998"
import script from "./CreateUpdateTemplateCategory.vue?vue&type=script&lang=js"
export * from "./CreateUpdateTemplateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports